import React from 'react';

/**
 * Keeps the removed package's disabled behaviour: without it the browser opens a file dropped on the box
 * and leaves the page, losing unsaved form edits. Needed on dragover too, or drop never fires on the box.
 * @param {React.DragEvent} event The dragover or drop event.
 */
function preventBrowserFileOpen(event) {
    event.preventDefault();
}

/**
 * @deprecated Static stand-in for the disabled react-dropzone-uploader box (removed for React 19), kept only for
 * the question Document Upload preview. Renders the package's exact disabled markup, styled by
 * DropzonePlaceholderGlobalStyle; nothing can be uploaded through it. New upload boxes don't use this.
 * @param {string} accept File types shown on the disabled file input.
 * @param {React.ReactNode} children The box's label content (icon, heading, hint).
 */
function DropzonePlaceholder({ accept, children }) {
    return (
        <div className="profile-doc-upload">
            <div
                className="dzu-dropzone dzu-dropzoneDisabled"
                onDragOver={preventBrowserFileOpen}
                onDrop={preventBrowserFileOpen}
            >
                <label className="dzu-inputLabel">
                    {/* The misspelled tag is what the ported CSS targets. */}
                    <lable>{children}</lable>
                    <input type="file" className="dzu-input" accept={accept} multiple disabled />
                </label>
            </div>
        </div>
    );
}

export default DropzonePlaceholder;
